import type { SearchResults } from 'algoliasearch-helper';

import { facetsToRadioItem } from '@/domains/productDiscovery/Listings/components/Filters/components/RadioSelect/utils/utils';

import type { Item } from '../interfaces';
import { allRadioFilterCategories } from '../translations';

const NB_FACET_VISIBLE = 6;
export const ALL_CATEGORIES_FACET_VALUE = 'allCategories';

export const generateCategoriesRadioItems = (
  values: SearchResults.FacetValue[] = [],
  limitedResult = false,
): Item[] => {
  const defaultItems = facetsToRadioItem(values);
  if (defaultItems && defaultItems.length) {
    const hasActiveDefaultElement = defaultItems.find((el) => el.active);
    const allCategoriesItem: Item = {
      active: !hasActiveDefaultElement,
      label: allRadioFilterCategories,
      value: ALL_CATEGORIES_FACET_VALUE,
      count: undefined,
    };
    defaultItems.unshift(allCategoriesItem);
  }
  return defaultItems.slice(0, limitedResult ? NB_FACET_VISIBLE : undefined);
};
